import axios from "axios";
import { User, UserLogin } from "@/types/user-type";
import { Response } from "@/types/response-type";
const API_URL = process.env.VUE_APP_BASE_URL;

export const sign_up_service = async (form: User): Promise<Response> => {
  try {
    const response = await axios({
      method: "POST",
      url: `${API_URL}/client_sign_up`,
      data: form,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      validateStatus: function (status: number): boolean {
        return status >= 200 && status <= 500;
      },
    });
    return response.data as Response;
  } catch (err) {
    const error = err as Error;
    return { status: 400, message: error.message } as Response;
  }
};

export const sign_in_service = async (form: UserLogin): Promise<Response> => {
  try {
    const response = await axios({
      method: "POST",
      url: `${API_URL}/client_sign_in`,
      data: form,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      validateStatus: function (status: number): boolean {
        return status >= 200 && status <= 500;
      },
    });
    return response.data as Response;
  } catch (err) {
    const error = err as Error;
    return { status: 400, message: error.message } as Response;
  }
};

export const validateDocument = async (form: any): Promise<Response> => {
  try {
    const response = await axios({
      method: "POST",
      url: `${API_URL}/validate-document`,
      data: form,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      validateStatus: function (status: number): boolean {
        return status >= 200 && status <= 500;
      },
    });
    return response.data as Response;
  } catch (err) {
    const error = err as Error;
    return { status: 400, message: error.message } as Response;
  }
};

export const recoveryPassword = async (form: any): Promise<Response> => {
  try {
    const response = await axios({
      method: "POST",
      url: `${API_URL}/recovery-password`,
      data: form,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      validateStatus: function (status: number): boolean {
        return status >= 200 && status <= 500;
      },
    });
    return response.data as Response;
  } catch (err) {
    const error = err as Error;
    return { status: 400, message: error.message } as Response;
  }
};

export const updatePassword = async (form: any): Promise<Response> => {
  try {
    const response = await axios({
      method: "POST",
      url: `${API_URL}/update-password`,
      data: form,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      validateStatus: function (status: number): boolean {
        return status >= 200 && status <= 500;
      },
    });
    return response.data as Response;
  } catch (err) {
    const error = err as Error;
    return { status: 400, message: error.message } as Response;
  }
};
